export default "/sun-down.6e04e2f7-253e71.png";